export const COLORS = [
    'primary darken-2', 'red darken-4', 'blue darken-4', 'purple darken-4',
]